import { ChangeEventHandler } from 'react';
import { Select } from 'nhsuk-react-components';
import { vaccineConditionTargetLabels } from 'utils/formattingUtils';

export type VaccineTargetProps = {
  value: string;
  onChange: ChangeEventHandler<HTMLSelectElement>;
};

export function VaccineTarget({
  value,
  onChange,
}: VaccineTargetProps) {
  const vaccineTypes = Object.entries(vaccineConditionTargetLabels)
    .map(([optValue, optLabel]) => ({ value: optValue, label: optLabel }));

  return (
    <Select
      label="Vaccine target"
      value={value}
      onChange={onChange}
      data-testid="vaccine-target"
    >
      {vaccineTypes.map((opt) => (
        <Select.Option key={opt.value} value={opt.value}>
          {opt.label}
        </Select.Option>
      ))}
    </Select>
  );
}
